import { isPlatformBrowser } from '@angular/common';
import * as i0 from '@angular/core';
import { inject, DestroyRef, PLATFORM_ID, Directive } from '@angular/core';
import { WA_WINDOW } from '@ng-web-apis/common';
import { EMPTY_FUNCTION } from '@taiga-ui/cdk/constants';
import { tuiCreateToken, tuiFontSizeWatcher } from '@taiga-ui/cdk/utils/miscellaneous';
const TUI_FONT_SIZE_HANDLER = tuiCreateToken();
let TuiFontSize = /*#__PURE__*/(() => {
  class TuiFontSize {
    constructor() {
      this.handler = inject(TUI_FONT_SIZE_HANDLER, {
        optional: true
      });
      this.nothing = inject(DestroyRef).onDestroy(this.handler && isPlatformBrowser(inject(PLATFORM_ID)) && typeof ResizeObserver !== 'undefined' ? tuiFontSizeWatcher(this.handler, inject(WA_WINDOW)) : EMPTY_FUNCTION);
    }
    static {
      this.ɵfac = function TuiFontSize_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || TuiFontSize)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: TuiFontSize
      });
    }
  }
  return TuiFontSize;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { TUI_FONT_SIZE_HANDLER, TuiFontSize };
